module.exports = __webpack_public_path__ + "static/P2101542-a0890a34235f01d247da3770bbe5358b.jpg";